<template>
  <router-view/>
</template>

<script setup>
  const color = localStorage.getItem('bg-color');
  const controlTagsColor = localStorage.getItem('control-tags-color');
  document.documentElement.style.setProperty('--bg-color', color);
  document.documentElement.style.setProperty('--tags-control-color', controlTagsColor);
</script>
